import gameday from '@gameday/common/assets/images/game_day.svg'
import { Email, Phone } from '@material-ui/icons'
import styled from 'styled-components'

const Wrapper = styled.nav`
  display: flex;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0 22px;
  align-items: center;
  justify-content: space-between;
  background-color: var(--light-text);
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
  @media only screen and (max-width: 540px) {
    height: 56px;
    min-height: auto;
    max-height: auto;
  }
`

const Logo = styled.img`
  max-height: 48px;
  margin: 10px 0;
  @media only screen and (max-width: 540px) {
    max-height: 38px;
    margin: 0;
  }
`

const Contact = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: var(--dark-text);
  &.mobile-nav {
    display: none;
    align-items: center;
    a {
      color: var(--dark-text);
      margin-left: 16px;
    }
  }
  @media only screen and (max-width: 540px) {
    &.desktop-nav {
      display: none;
    }
    &.mobile-nav {
      display: inline-flex;
    }
  }
`
const Pipe = styled.span`
  margin: 0 10px;
  color: var(--dark-text);
  opacity: 0.7;
`

const Nav = ({ email, logo, phone, title }) => (
  <Wrapper>
    {logo && <Logo src={logo} alt={title && title} />}
    <Contact className="desktop-nav">
      {phone && phone}
      {email && phone && <Pipe>|</Pipe>}
      {email && email}
    </Contact>
    <Contact className="mobile-nav">
      {phone && (
        <a href={`tel:${phone}`}>
          <Phone />
        </a>
      )}
      {email && (
        <a href={`mailto:${email}`}>
          <Email />
        </a>
      )}
    </Contact>
  </Wrapper>
)

Nav.defaultProps = {
  email: '',
  logo: gameday,
  phone: '',
  title: '',
}

export default Nav
